<div class="db-one-month-free-select-plan__plans mb20">
  <div class="ds-card-radio" *ngFor="let plan of plans; let _index = index"
       [ngClass]="{'active': chosenPlanIndex == _index}"
       (click)="chosenPlanIndex = _index; changePlan()">
    <input class="ds-radio ds-radio-small" type="radio" id="{{_index}}" [value]="_index" name="plan"
           [(ngModel)]="chosenPlanIndex">
    <label for="{{_index}}"></label>
    <p class="ds-card-radio-text" [innerHTML]="plan?.title"></p>
    <p class="ds-card-radio-text">
      <b [innerHTML]="plan?.hostedDomainsCount + ' site' + (plan?.hostedDomainsCount > 1 ? 's' : '')"></b>
    </p>
  </div>
</div>
<hr *ngIf="!isPercentOffer">
<div class="db-one-month-free-select-plan__period-type" [ngClass]="{'percent': isPercentOffer}">
  <div class="mb12">
    <input class="ds-radio ds-radio-small" type="radio" id="month" value="month" name="duration"
           [(ngModel)]="chosenPlanOption" (change)="changePlan()">
    <label for="month"><b>{{'text_periodMonthly' | dbText}}</b></label>
    <p *ngIf="isPercentOffer" class="db-one-month-free-select-plan__sub-label a"><span>${{(plans[chosenPlanIndex].monthlyPrice * (10/7)) | DbNumberFormatPipe}}</span> ${{(plans[chosenPlanIndex].monthlyPrice) | DbNumberFormatPipe}}/mo</p>
    <p *ngIf="!isPercentOffer" class="db-one-month-free-select-plan__sub-label b">${{(plans[chosenPlanIndex].monthlyPrice) | DbNumberFormatPipe}}/mo</p>  </div>
  <div>
    <input class="ds-radio ds-radio-small" type="radio" id="year" value="year" name="duration"
           [(ngModel)]="chosenPlanOption" (change)="changePlan()">
    <label for="year"><b>{{'text_periodYearly' | dbText}}</b>
      <div *ngIf="!isPercentOffer" class="ds-label ds-label-small"><span>Best value</span></div>
    </label>
    <p *ngIf="isPercentOffer" class="db-one-month-free-select-plan__sub-label c"><span>${{((plans[chosenPlanIndex].yearlyPrice / 12) * (10/7)) | DbNumberFormatPipe: 'floor'}}</span> ${{(plans[chosenPlanIndex].yearlyPrice / 12) | DbNumberFormatPipe: 'floor'}}/mo
      (${{plans[chosenPlanIndex].yearlyPrice}} billed annually)</p>
    <p *ngIf="!isPercentOffer" class="db-one-month-free-select-plan__sub-label d">${{(plans[chosenPlanIndex].yearlyPrice / 12) | DbNumberFormatPipe: 'floor'}}/mo
      (${{plans[chosenPlanIndex].yearlyPrice}} billed annually)</p>
  </div>
</div>
